// extracted by mini-css-extract-plugin
export var bullet = "_ml-q";
export var bulletText = "_ml-p";
export var bullets = "_ml-k";
export var callout = "_ml-g";
export var calloutBody = "_ml-i";
export var calloutLabel = "_ml-h";
export var checkIcon = "_ml-m";
export var checkList = "_ml-j";
export var checkSvg = "_ml-n";
export var checkText = "_ml-o";
export var fieldCard = "_ml-1";
export var fieldDescription = "_ml-5";
export var fieldHeader = "_ml-3";
export var fieldTitle = "_ml-4";
export var finalNote = "_ml-s";
export var flow = "_ml-x";
export var flowArrow = "_ml-v";
export var flowStep = "_ml-u";
export var helperText = "_ml-r";
export var inlineTitle = "_ml-t";
export var listItem = "_ml-l";
export var noteBody = "_ml-8";
export var noteBodyText = "_ml-9";
export var noteCard = "_ml-2";
export var noteIcon = "_ml-6";
export var noteTitle = "_ml-7";
export var productChoices = "_ml-w";
export var radioDot = "_ml-d";
export var radioDotSelected = "_ml-e";
export var radioDotSvg = "_ml-f";
export var selectableCard = "_ml-b";
export var selectableCardSelected = "_ml-c";
export var strongText = "_ml-a";
export var subHeading = "_ml-0";